export default __webpack_public_path__ + "static/media/greta.472501b0.jpg";